import React from "react";
import { useDispatch } from "react-redux";
import { TagStatusUi } from "../../ui/TagStatusUi";
import { Space } from "antd";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { perfilSetActive, perfilStartDelete } from "../../../actions/usuario";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { TableUi } from "../../ui/TableUi";

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Nombres",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "¿Está activo?",
    dataIndex: "estado",
    key: "estado",
    render: (text) => <TagStatusUi status={text} />,
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <ButtonUi
          typeUi={TipoButtonConstants.EditarTable}
          onClick={() => acciones.handleEditar(record)}
          displayText={false}
        />
        <ButtonUi
          typeUi={TipoButtonConstants.EliminarTable}
          onClick={() => acciones.handleEliminar(record)}
          displayText={false}
        />
      </Space>
    ),
  },
];
export const PerfilTable = ({ perfiles, handleOpenRutaForm }) => {
  const dispatch = useDispatch();
  const handleEditar = (ruta) => {
    dispatch(perfilSetActive(ruta));
    handleOpenRutaForm();
  };
  const handleEliminar = (ruta) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar el perfil seleccionado?",
      ruta.nombre,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(perfilStartDelete(ruta));
        }
      }
    );
  };
  return (
    <TableUi
      data={perfiles}
      columns={columns({ handleEditar, handleEliminar })}
      size="small"
      rowKey="id"
    />
  );
};
